import styled from 'styled-components';

const ContentStyles = styled.section`
  img {
    display: flex;

    &.aligncenter {
      margin: 0 auto;
    }

    &.alignright {
      margin: 0 0 0 auto;
    }
  }

  @media (min-width: 768px) {
    .inner {
      margin: 0 auto;
    }
  }
`;

export default ContentStyles;
